// store/modules/itemIncome/actions.js
import ItemIncomeApi from "../../../api/modules/ItemIncomeApi";

const searchIncomes = (_, payload) => {
  return ItemIncomeApi.searchIncomes(payload.context, payload);
};

const getById = (_, payload) => {
  return ItemIncomeApi.getIncomeById(payload.context, payload.id);
};

const saveIncome = (_, payload) => {
  return ItemIncomeApi.saveIncome(payload.context, payload.payload);
};

const changeStatusIncome = (_, payload) => {
  return ItemIncomeApi.changeStatusIncome(payload.context, payload.idIncome, payload.request);
};

const updateRegistrationDate = (_, payload) => {
  return ItemIncomeApi.updateRegistrationDate(payload.context, {idIncome: payload.idIncome,
    registrationDate: payload.registrationDate
  });
};

const assignItems = (_, payload) => {
  return ItemIncomeApi.assignItems(payload.context, {incomeId: payload.incomeId, data: payload.data});
};

export default {
  searchIncomes,
  getById,
  saveIncome,
  changeStatusIncome,
  updateRegistrationDate,
  assignItems
};



// WEBPACK FOOTER //
// ./src/store/modules/itemIncome/actions.js